









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CheckIcon, UsersIcon, XIcon } from 'vue-feather-icons';
import { CUSTOMER_TYPE_LABELS, CustomerType } from 'admiral-core';

@Component({
  name: 'CustomerTypeFilter',
  components: { UsersIcon, CheckIcon, XIcon },
})
export default class CustomerTypeFilter extends Vue {
  @Prop({ type: Array, default: () => [] })
  typeFilter!: CustomerType[];

  hovered = false;

  /** Privatperson und Firma. */
  get typeOptions(): { value: CustomerType; label: string }[] {
    return [CustomerType.NATURAL, CustomerType.LEGAL].map((value) => ({
      value,
      label: CUSTOMER_TYPE_LABELS[value],
    }));
  }

  get displayLabel(): string {
    if (this.typeFilter.length === 0) {
      return 'Alle Typen';
    }
    if (this.typeFilter.length === 1) {
      return CUSTOMER_TYPE_LABELS[this.typeFilter[0]];
    }
    return `${CUSTOMER_TYPE_LABELS[this.typeFilter[0]]} + ${this.typeFilter.length - 1}`;
  }

  isSelected(value: CustomerType): boolean {
    return this.typeFilter.includes(value);
  }

  /** Schaltet einen Typ im Mehrfachfilter. */
  toggleType(value: CustomerType) {
    const newTypes = this.isSelected(value)
      ? this.typeFilter.filter((t) => t !== value)
      : [...this.typeFilter, value];
    this.$emit('update:typeFilter', newTypes);
  }

  clearFilter() {
    this.$emit('update:typeFilter', []);
  }
}
